import React, { useEffect, useState } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { Box, CircularProgress, Typography } from '@mui/material'
import useAuthStore from '../../store/authStore'
import { authAPI } from '../../utils/api'

const AuthGuard = ({ children }) => {
  const { isAuthenticated, token, setLoading, logout } = useAuthStore()
  const [isVerifying, setIsVerifying] = useState(true)
  const location = useLocation()

  useEffect(() => {
    const verifyToken = async () => {
      if (!token) {
        setIsVerifying(false)
        return
      }

      try {
        setLoading(true)
        await authAPI.verify()
        setIsVerifying(false)
      } catch (error) {
        console.error('Token verification failed:', error)
        logout()
        setIsVerifying(false)
      } finally {
        setLoading(false)
      }
    }

    verifyToken()
  }, [token, setLoading, logout])

  // Show loading spinner while verifying token
  if (isVerifying) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="100vh"
        gap={2}
      >
        <CircularProgress size={40} />
        <Typography variant="body2" color="text.secondary">
          Verificando sesión...
        </Typography>
      </Box>
    )
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return children
}

export default AuthGuard
